import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    ReserveTableWidget: {
        background: '#f5f6fa',
        padding: '17px',
        width: '100%',
        // width: '40vw',
        '& .title' : {
            padding: '1rem',
            textAlign: 'center'
        },
        '& .Btn--Primary': {
            "background": "#6E7187",
            "boxShadow": "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            "borderRadius": "8px",
            "fontWeight": "700",
            "fontSize": "12px",
            "lineHeight": "15px",
            "textAlign": "center",
            "textTransform": "uppercase",
            "color": "#FFFFFF",
            // boxShadow: 'none',
            border: 'none',
            padding: '16px',
            display: 'block',
            width: '100%'
        },
        '& .Btn--Secondary': {
            "background": "#e14954",
            "boxShadow": "0px 10px 30px rgba(0, 0, 0, 0.07), 0px 4px 18px rgba(249, 98, 83, 0.25)",
            "borderRadius": "8px",
            "fontWeight": "700",
            "fontSize": "12px",
            "lineHeight": "15px",
            "textAlign": "center",
            "textTransform": "uppercase",
            "color": "#FFFFFF",
            // boxShadow: 'none',
            border: 'none',
            padding: '16px',
            display: 'block',
            width: '100%'
        }
    },
    SmallTablePlaceholderWrapper: {
        marginBottom: '20px'
    },
    Customer: {
        marginBottom: '20px',
        '& .CustomerTitle': {
            "fontStyle": "normal",
            "fontWeight": "700",
            "fontSize": "14px",
            "lineHeight": "17px",
            "textTransform": "uppercase",
            "color": "#271D1C",
            marginBottom: '4px'
        },
        '& .CustomerInput': {
            position: 'relative',
            '& input': {
                "background": "#FFFFFF",
                "border": "1px solid #e5e9f2",
                padding: '16px 46px',
                "fontStyle": "normal",
                "fontWeight": "500",
                "fontSize": "16px",
                "lineHeight": "19px",
                "color": "rgba(110, 113, 135, 0.5)",
                display: 'block',
                width: '100%'
            },
            '& i': {
                position: 'absolute',
                top: '50%',
                left: '16px',
                transform: 'translateY(-50%)',
                fontSize: '23px',
                color: '#6E7187'
            }
        }
    },
    BtnSearch: {
        "fontWeight": "700",
        "fontSize": "14px",
        "lineHeight": "17px",
        "textTransform": "uppercase",
        "color": "#6E7187",
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        "border": "1px solid #6E7187",
        "borderRadius": "8px",
        padding: '14px',
        cursor: 'pointer',
        background: '#f5f6fa',
        '& .IconWrap': {
            "width": "24px",
            "height": "24px",
            "background": "#6E7187",
            "borderRadius": "4px",
            color: "#fff",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
            marginRight: '8px'
        }
    },
    Customers: {
        marginBottom: '12px',
        '& .Customers__Title': {
            "fontStyle": "normal",
            "fontWeight": "700",
            "fontSize": "14px",
            "lineHeight": "17px",
            "textTransform": "uppercase",
            "color": "#6E7187",
            marginBottom: '12px'
        },
        '& .Customers__List': {
            '&>div': {
                "fontStyle": "normal",
                "fontWeight": "600",
                "fontSize": "14px",
                "lineHeight": "17px",
                "color": "#e14954",
                padding: '17px',
                "background": "#FFFFFF",
                "borderRadius": "8px",
                marginBottom: '8px',
                cursor: 'pointer',
                transition: '0.2s all',
                '&:hover': {
                    "color": "#FFFFFF",
                    "background": "#e14954",
                }
            }
        }
    },
    Footer: {
        display:'flex',
        justifyContent: "space-between"
    }
}));
